var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.availability
    ? _c(
        "span",
        {
          class: _vm.classes,
          style: _vm.paddingStyles,
          attrs: { "data-bx-item-id": "availability=" + _vm.availability.id },
        },
        [_c("span", [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }